import PolicyLayout from "../components/PolicyLayout";
import { useEffect } from "react";

export default function CookiesPage() {
    useEffect(() => {
        document.title = "Cookie-politik · Cleany.dk";
    }, []);

    const openSettings = () => {
        try {
            window.dispatchEvent(new CustomEvent("cleany:open-cookie-settings"));
        } catch {
            /* ignore */
        }
    };

    return (
        <PolicyLayout title="Cookie-politik" lastUpdated="3. maj 2026">
            <p className="lead">
                Cleany.dk bruger cookies for at sikre, at hjemmesiden fungerer korrekt
                og for at forstå, hvordan vores besøgende anvender den. Du har altid
                kontrol over, hvilke cookies du accepterer.
            </p>

            <div className="my-6 rounded-2xl border border-sky-100 bg-sky-50/60 p-5">
                <p className="m-0 text-sm text-slate-700">
                    Du kan til enhver tid ændre dit samtykke ved at klikke på knappen
                    nedenfor.
                </p>
                <button
                    type="button"
                    onClick={openSettings}
                    data-testid="open-cookie-settings"
                    className="mt-3 inline-flex items-center gap-2 rounded-full bg-sky-600 hover:bg-sky-700 text-white font-semibold text-sm h-10 px-5"
                >
                    Åbn cookie-indstillinger
                </button>
            </div>

            <h2>1. Hvad er cookies?</h2>
            <p>
                Cookies er små tekstfiler, der gemmes i din browser, når du besøger en
                hjemmeside. De bruges til at huske dine præferencer og indsamle
                statistik om brugen af siden.
            </p>

            <h2>2. Hvilke cookies bruger vi?</h2>

            <h3>Nødvendige cookies (altid aktive)</h3>
            <p>
                Disse cookies er strengt nødvendige, for at hjemmesiden kan fungere.
                Eksempler:
            </p>
            <ul>
                <li>
                    <strong>cleany_cookie_consent</strong> – husker dit samtykke til
                    cookies. Udløb: 12 måneder.
                </li>
                <li>
                    <strong>cleany_referred_by</strong> – husker referral-koden, hvis du
                    er kommet til siden via et referral-link. Udløb: 90 dage.
                </li>
            </ul>

            <h3>Statistik-cookies (samtykke kræves)</h3>
            <p>
                Disse cookies hjælper os med at forstå, hvordan besøgende bruger
                hjemmesiden, så vi kan forbedre den. De aktiveres kun, hvis du har
                accepteret dem.
            </p>
            <ul>
                <li>
                    <strong>PostHog</strong> – product analytics. Cookies sat af PostHog
                    måler bl.a. sidevisninger, klik og navigationsmønstre. Udløb: op til
                    13 måneder.
                </li>
            </ul>

            <h2>3. Tredjepartstjenester</h2>
            <p>
                Vores hjemmeside kan indlejre indhold fra tredjeparter (fx Google
                Calendar til mødebooking). Disse tjenester kan sætte deres egne cookies,
                som er omfattet af tjenesternes egne politikker.
            </p>

            <h2>4. Sådan håndterer du cookies i din browser</h2>
            <p>
                Du kan slette eller blokere cookies via din browsers indstillinger.
                Bemærk dog, at hjemmesiden muligvis ikke fungerer optimalt, hvis du
                blokerer alle cookies.
            </p>
            <ul>
                <li>
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
                        Google Chrome
                    </a>
                </li>
                <li>
                    <a href="https://support.mozilla.org/da/kb/aktiver-deaktiver-cookies-internetsider-spore" target="_blank" rel="noopener noreferrer">
                        Mozilla Firefox
                    </a>
                </li>
                <li>
                    <a href="https://support.apple.com/da-dk/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
                        Apple Safari
                    </a>
                </li>
                <li>
                    <a href="https://support.microsoft.com/da-dk/microsoft-edge/slet-cookies-i-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">
                        Microsoft Edge
                    </a>
                </li>
            </ul>

            <h2>5. Kontakt</h2>
            <p>
                Hvis du har spørgsmål til vores brug af cookies, er du velkommen til at
                skrive til <a href="mailto:info@cleany.dk">info@cleany.dk</a>.
            </p>
        </PolicyLayout>
    );
}
